import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserNamesAPI from '../api/UserNamesAPI';

// The signed-in user's searched player names, for the Player-filter dropdown. Stays empty for
// signed-out visitors (the thunks are only dispatched when authenticated).
export type SearchNamesStateType = {
  names: string[];
  loaded: boolean;
};

export const SearchNamesInitialState: SearchNamesStateType = {
  names: [],
  loaded: false,
};

export const fetchSearchNames = createAsyncThunk('searchNames/fetch', async () => {
  return await UserNamesAPI.getSearchNames();
});

// Auto-add on search. The reducer moves the name to the front optimistically; the POST persists it.
export const addSearchName = createAsyncThunk('searchNames/add', async (username: string) => {
  await UserNamesAPI.addSearchName(username);
  return username;
});

export const removeSearchName = createAsyncThunk('searchNames/remove', async (username: string) => {
  await UserNamesAPI.removeSearchName(username);
  return username;
});

const slice = createSlice({
  name: 'searchNames',
  initialState: SearchNamesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSearchNames.fulfilled, (state, action) => {
      state.names = action.payload;
      state.loaded = true;
    });
    // Optimistic on dispatch. Case-insensitive de-dupe and move-to-front mirror the server's ordering.
    builder.addCase(addSearchName.pending, (state, action) => {
      const name = action.meta.arg.trim();
      if (name === '') {
        return;
      }
      state.names = [name, ...state.names.filter((n) => n.toLowerCase() !== name.toLowerCase())];
    });
    builder.addCase(removeSearchName.pending, (state, action) => {
      const name = action.meta.arg.toLowerCase();
      state.names = state.names.filter((n) => n.toLowerCase() !== name);
    });
  },
});

export default slice.reducer;
